export default {
  patient: {
    welcome: 'Hello! Here is your health summary',
    welcomeName: 'Hello, {{name}}!',
    newAppointment: 'New Appointment',
    actionRequired: 'Action Required',
    nextConsultation: 'Next Consultation',
    keepControl: 'Keep control of your health',
    noAppointment: 'No appointments scheduled at the moment.',
    joinWaitingRoom: 'Join waiting room',
    bookNow: 'Book an appointment now',
    manageActivities: 'Manage my activities',
    messages: 'Messages',
    unread: 'unread',
    vitals: 'Your Vitals',
    live: 'Live',
    pulse: 'Pulse',
    bloodPressure: 'Blood Pressure',
    weight: 'Weight',
    temperature: 'Temperature',
    justUpdated: 'Just updated',
    noData: 'No data',
    activePrescriptions: 'Active Prescriptions',
    prescription: 'Prescription',
    recentMedicalRecords: 'Recent Medical Records',
    viewAll: 'View all',
    medication: 'Medication',
    unknownDoctor: 'Unknown',
    noActivePrescription: 'No active prescriptions.',
    recentActivity: 'Recent Activity',
    completedConsultation: 'Consultation completed',
    pendingConsultation: 'Consultation pending',
    withDoctor: 'with Dr. {{name}}',
    details: 'Details',
    noHistory: 'Your consultation history will appear here.',
    patient: 'Patient',
    doctor: 'Doctor',
    generalist: 'Generalist',
    clinicalConsultation: 'Clinical Consultation',
    consultationWithDoctor: 'Consultation with Dr. {{name}}',
    medicalFollowUp: 'Medical follow-up',
    emergency: {
      title: "Emergency Protocol",
      subtitle: "Immediate assistance",
      description: "In case of an immediate emergency (chest pain, breathing difficulties, loss of consciousness), do not wait for a teleconsultation. SAMU is your absolute priority.",
      callSamu: "CALL 15 (SAMU)",
      europe: "EUROPE (112)"
    },
    conflictModal: {
      title: "Active Session",
      subtitle: "A teleconsultation is already in progress.",
      description: "It seems you already have an open session. Would you like to rejoin it to continue your medical discussion?",
      rejoin: "Rejoin Consultation",
      cancel: "Cancel"
    }
  },
  notificationCenter: {
    unreadAlerts_one: '{{count}} Priority Notification',
    unreadAlerts_other: '{{count}} Priority Notifications',
    noActiveAlerts: 'No active alerts',
    markAsRead: 'Mark as read',
    dismiss: 'Dismiss'
  },
  doctor: {
    availabilityControl: {
      title: 'Availability status',
      update: 'Update status',
      updating: 'Updating...',
      activeStatus: 'ACTIVE',
      lastCheck: 'Last check: {{time}}',
      available: {
        label: 'Available',
        desc: 'Ready for consultations'
      },
      busy: {
        label: 'Busy',
        desc: 'In consultation'
      },
      offline: {
        label: 'Offline',
        desc: 'Unavailable'
      }
    }
  },
  invoicesSection: {
    title: 'My Invoices & Payments',
    fetchingDocuments: 'Retrieving your documents...',
    noInvoiceAvailable: 'No invoices available at the moment.',
    invoiceNumber: 'Invoice #{{id}}',
    paid: 'Paid',
    downloadPdf: 'Download PDF',
    viewFullHistory: 'VIEW FULL HISTORY',
    documentsCount_one: '{{count}} DOCUMENT',
    documentsCount_other: '{{count}} DOCUMENTS'
  },
  healthQuest: {
    quests: {
      identity: 'Verified Identity',
      phone: 'Active Lifeline',
      medical: 'Medical Grounds',
      emergency: 'Guardian Angel'
    },
    ranks: {
      elite: 'ELITE PATIENT',
      adept: 'HEALTH ADEPT',
      initiate: 'HEALTH INITIATE'
    },
    title: 'Your Health Ascent',
    rankLabel: 'RANK:',
    continueQuest: 'Continue my Quest'
  },
  doctorDashboard: {
    doctorPrefix: 'Dr. {{name}}',
    doctor: 'Doctor',
    securedHds: 'Secured HDS',
    interfaceElite: 'Elite Interface • Active Session',
    newSession: 'New Session',
    live: 'Live',
    activeConsultation: 'Active Consultation',
    patientNumber: 'Patient #{{id}}',
    startedAt: 'Started at {{time}}',
    statusLabel: 'Status: {{status}}',
    rejoinCall: 'Rejoin Call',
    todayAppointments: "Today's Appointments",
    today: 'Today',
    viewAll: 'View All',
    generalConsultation: 'General consultation',
    noAppointmentPlanned: 'No appointments scheduled',
    stats: {
      waitingQueue: 'Waiting Queue',
      patients: 'Patients',
      emergencies: 'Emergencies',
      immediateAction: 'Immediate Action',
      nextAppointment: 'Next Appointment',
      freeSlot: 'Free'
    },
    timeline: 'Timeline',
    activityStream: 'Activity Stream',
    noUpcomingEvent: 'No upcoming events',
    ekoseConsultation: 'EKOSE Consultation',
    alertsCenter: 'ALERTS CENTER',
    messages: 'Messages',
    quickActions: 'QUICK ACTIONS',
    waitingRoom: 'Waiting Room',
    prescriptions: 'Prescriptions'
  },
  performance: {
    title: 'API Performance Monitoring',
    timeWindow: 'Time Window',
    timeWindows: {
      oneMin: '1 minute',
      fiveMin: '5 minutes',
      fifteenMin: '15 minutes',
      oneHour: '1 hour',
      sinceBeginning: 'From the beginning'
    },
    totalRequests: 'Total Requests',
    averageResponseTime: 'Average Response Time',
    errorRate: 'Error Rate',
    slowRequests: 'Slow Requests',
    ofTotal: '{{percentage}}% of total',
    responseTime: 'Response Time',
    fastest: 'Fastest: {{time}}ms',
    slowest: 'Slowest: {{time}}ms',
    average: 'Average: {{time}}ms',
    slowestEndpoints: 'Slowest Endpoints',
    noData: 'No data available',
    globalHealth: 'Global Health',
    performanceLabel: 'Performance',
    stability: 'Stability',
    exportData: 'Export Data',
    close: 'Close'
  },
  charts: {
    donut: {
      defaultTitle: 'Users Distribution',
      subtitle: 'Distribution by profile typology',
      users: 'Users',
      growthRate: 'Growth Rate',
      activeUsers: 'Active Users',
      registrations24h: '24h Signups',
      labels: {
        patients: 'Patients',
        doctors: 'Doctors',
        medecins: 'Doctors',
        administrators: 'Administrators',
        admins: 'Admins'
      }
    },
    activity: {
      title: 'Weekly Activity',
      subtitle: 'Real-time tracking of interactions',
      total: 'TOTAL',
      legends: {
        consults: 'Consults',
        registrations: 'Signups',
        messages: 'Messages'
      },
      categories: {
        consultations: 'Consultations',
        registrations: 'Signups',
        messages: 'Messages'
      },
      days: {
        lun: 'Mon',
        mar: 'Tue',
        mer: 'Wed',
        jeu: 'Thu',
        ven: 'Fri',
        sam: 'Sat',
        dim: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      }
    }
  }
};
